import { PropsWithChildren } from 'react';

import { ColorKeys } from '~lib/styles/Theme/colors';

import { Typography } from './constant';
import * as S from './style';

export type TypographyKey = keyof typeof Typography;

export interface TextProps {
  typography: TypographyKey;
  as?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'li';
  dangerouslySetInnerHTML?: {
    __html: string;
  };
  color?: ColorKeys;
}

export default function Text({
  typography,
  children,
  as,
  color,
  ...rest
}: PropsWithChildren<TextProps>) {
  return (
    <S.TypoComponent typography={typography} as={as} color={color} {...rest}>
      {children}
    </S.TypoComponent>
  );
}
